import { useTranslation } from 'react-i18next';

import { Button, Icon } from '@hotjar/hotsauce';

import { BillingAlert } from './BillingAlert';

interface Props {
  onContactCustomerSuccessLinkClick: () => void;
}

export const YearlyBillingCycleLockedBanner = ({
  onContactCustomerSuccessLinkClick,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <BillingAlert
      /* @ts-expect-error: FIXME: Using color magenta_600 is not allowed in Icon. */
      icon={<Icon icon="lock" color="magenta_600" size="xl" />}
      title={t('revenue:plans-and-billing-page.alerts.yearly-billing-cycle-locked.title')}
      subtitle={t('revenue:plans-and-billing-page.alerts.yearly-billing-cycle-locked.subtitle')}
      cta={
        <Button kind="secondary" onClick={() => onContactCustomerSuccessLinkClick()}>
          {t('revenue:plans-and-billing-page.alerts.yearly-billing-cycle-locked.cta')}
        </Button>
      }
    />
  );
};
